import { render, staticRenderFns } from "./PostDoc.vue?vue&type=template&id=29487bb9&scoped=true&"
import script from "./PostDoc.vue?vue&type=script&lang=js&"
export * from "./PostDoc.vue?vue&type=script&lang=js&"
import style0 from "./PostDoc.vue?vue&type=style&index=0&id=29487bb9&prod&lang=scss&"
import style1 from "./PostDoc.vue?vue&type=style&index=1&id=29487bb9&prod&lang=scss&scoped=true&"
import style2 from "./PostDoc.vue?vue&type=style&index=2&id=29487bb9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29487bb9",
  null
  
)

export default component.exports